import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'ax-search-query',
  templateUrl: 'search-query.component.html',
  styleUrls: ['search-query.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchQueryComponent),
      multi: true,
    },
  ],
})
export class SearchQueryComponent implements ControlValueAccessor {
  @Input() autofocus = true;
  @Input() placeholder = 'label.search';
  @Output() immediatelySearch: EventEmitter<void> = new EventEmitter();

  _value: string | undefined;
  _onChange: (_: any) => void;
  _onTouched: () => void;

  writeValue(value: string): void {
    this._value = value;
  }

  registerOnChange(fn: (_: any) => void): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  setValue(value: string | undefined) {
    if (this._value !== value) {
      this._value = value;
      if (this._onChange) {
        this._onChange(this._value);
      }
    }
  }

  searchImmediately() {
    this.immediatelySearch.emit();
  }

  clearValue() {
    this.setValue('');
    if (this._onTouched) {
      this._onTouched();
    }
  }
}
